import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import "./App.css";
import Home from "./Pages/Home";
import AppContext from "./Components/AppContext";

const App = () => {
	const [lang, setLang] = useState("en");
	const [selectedString, setSelectedString] = useState("");

	const store = {
		lang: { get: lang, set: setLang },
		selectedString: { get: selectedString, set: setSelectedString },
	};

	return (
		<AppContext.Provider value={store}>
			<div className="wrapper">
				<Router>
					<Routes>
						<Route path="/" element={<Home language="de" />} />
						<Route path="/index-en.htm" element={<Home language="en" />} />
					</Routes>
				</Router>
			</div>
		</AppContext.Provider>
	);
};

export default App;
